export const achievements=[
    {
        achievementName:'Google Cloud Certified Associate Cloud Engineer',
        achievementDate:'(Dec’20)'
    },
    {
        achievementName:'AWS Certified Developer - Associate',
        achievementDate:'(Nov’20)'
    },
    {
        achievementName:'Top 50 in National Engineering Olympiad',
        achievementDate:'(May’18)'
    },
    {
        achievementName:'Top 30 in Maharashtra Talent State Exam for 3 consecutive years',
        achievementDate:'(Apr’12, Apr’13, Apr’14)'
    },
    {
        achievementName:'Qualified for final stage of National Talent Search Examination',
        achievementDate:'(May’12, May’14)'
    }
]